export const FETCH_COMMISSION = 'FETCH_COMMISSION';
export const FETCH_COMMISSION_SUCCESS = 'FETCH_COMMISSION_SUCCESS';
export const FETCH_COMMISSION_FAIL = 'FETCH_COMMISSION_FAIL';
export const FETCH_COMMISSION_BY_TIME = 'FETCH_COMMISSION_BY_TIME';
export const FETCH_COMMISSION_BY_TIME_SUCCESS = 'FETCH_COMMISSION_BY_TIME_SUCCESS';
export const FETCH_COMMISSION_BY_TIME_FAIL = 'FETCH_COMMISSION_BY_TIME_FAIL';
